(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name
     *
     * @description
     *
     */
    angular
        .module('targetHours')
        .factory('TargetHoursFactory', TargetHoursFactory);

    function TargetHoursFactory() {

    	function TargetHoursDTO(){
    		this.group = null;
    		this.calTargetHours = false;
    		this.fixedCrewData =[];
    		this.acType = null;
    		this.cycle = null;
    		this.crewType = null;
    		this.base = null;
        this.contractType = null;
    	}

    	function TargetDTO(){
    		this.crewTargetHourId = null;
    		this.version = null;
    		this.isFixed = false;
    		this.crewId = null;
    		this.crewName = null;
    		this.crewGroup = null;
    		this.past11MonthsHrs = null;
    		this.lastYearMonthHrs = null;
    		this.calendarYearHrs = null;
    		this.crewAvailability = null;
    		this.availability = null;
    		this.crewProfileId = null;
    		this.targetHrs = [];
    		this.accountedHrs = null;
    		this.differneceHrs = null;
    		this.targetNightHrs = [];
    		this.targetNightDepartures = [];
    		this.targetDutyHrs = [];
    		this.targetSbHrs = [];
    		this.totalTargetHrs = null;
        this.isCrewOnFlexiContract = null;
        this.fixedFlexiHrs = null;
    	}

    	function HoursDTO(){
    		this.modelNumber = null;
    		this.hours = null;
    		this.isFixed = false;
    		this.crewTargetHourId = null;
    		this.version = null;
    	}

    	function FixedCrewDTO(){
    		this.crewTargetHourId = null;
    		this.version = null;
    		this.isFixed = null;
    		this.crewId = null;
    		this.crewName = null;
    		this.crewGroup = null;
    		this.past11MonthsHrs = null;
    		this.lastYearMonthHrs = null;
    		this.calendarYearHrs = null;
    		this.targetHrs = null;
    		this.accountedHrs = null;
    		this.differneceHrs = null;
    		this.availability = null;
    		this.crewProfileId = null;
    		this.targetNightHrs = null;
    		this.targetNightDepartures = null;
    		this.modelNumber = null;
    		this.targetDutyHrs = null;
    		this.targetSbHrs = null;
    		this.crewAvailability = null;
    	}

    	function SaveDTO(){
    		this.targetHours = [];
    		this.cycleID = null;
    	}

    	function GetSearchCriteria() {
            return new TargetHoursDTO();
        }

    	function GetTargetHoursDto() {
			return new TargetDTO();
		}

    	function GetSaveRequest(){
    		return new SaveDTO();
    	}

    	function GetFormattedList(list) {
			var dataList = [];
			var tempId = null;

			if (!!list && list.length > 0) {
				for (var i = 0; i < list.length; i++) {
					if(tempId !== list[i].crewProfileId){
						var dto = new TargetDTO();
							dto.crewTargetHourId = list[i].crewTargetHourId;
							dto.version =  list[i].version;
							dto.crewId = list[i].crewId;
							dto.crewName = list[i].crewName;
							dto.crewGroup = list[i].crewGroup;
							dto.past11MonthsHrs = list[i].past11MonthsHrs;
							dto.lastYearMonthHrs = list[i].lastYearMonthHrs;
							dto.calendarYearHrs = list[i].calendarYearHrs;
							dto.availability = list[i].availability;
							dto.crewAvailability = list[i].crewAvailability;
							dto.crewProfileId = list[i].crewProfileId;
							dto.targetHrs.push(
									adaptHours(list[i].modelNumber,list[i].targetHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
							dto.accountedHrs = list[i].accountedHrs;
							dto.differneceHrs = list[i].differneceHrs;
							dto.totalTargetHrs = list[i].targetHrs;
							dto.targetNightHrs.push(
									adaptHours(list[i].modelNumber,list[i].targetNightHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
							dto.targetNightDepartures.push(
									adaptHours(list[i].modelNumber,list[i].targetNightDepartures,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
							dto.targetDutyHrs.push(
									adaptHours(list[i].modelNumber,list[i].targetDutyHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
							dto.targetSbHrs.push(
									adaptHours(list[i].modelNumber,list[i].targetSbHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
              dto.isCrewOnFlexiContract = list[i].crewOnFlexiContract;
              dto.fixedFlexiHrs = list[i].fixedFlexiHrs;
						dataList.push(dto);
					}else{
						var k = dataList.length-1;
						dataList[k].targetHrs.push(
								adaptHours(list[i].modelNumber,list[i].targetHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
						dataList[k].targetNightHrs.push(
								adaptHours(list[i].modelNumber,list[i].targetNightHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
						dataList[k].targetNightDepartures.push(
								adaptHours(list[i].modelNumber,list[i].targetNightDepartures,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
						dataList[k].targetDutyHrs.push(
								adaptHours(list[i].modelNumber,list[i].targetDutyHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
						dataList[k].targetSbHrs.push(
								adaptHours(list[i].modelNumber,list[i].targetSbHrs,list[i].isFixed,list[i].crewTargetHourId,list[i].version));
						dataList[k].accountedHrs = dataList[k].accountedHrs + list[i].accountedHrs;
						dataList[k].differneceHrs = dataList[k].differneceHrs + list[i].differneceHrs;
						dataList[k].totalTargetHrs = dataList[k].totalTargetHrs + list[i].targetHrs;

					}
					tempId = list[i].crewProfileId;
				}
			}
			return dataList;
		}

    	function adaptHours(modelNumber,hrs,isFixed,id,version){
    		var hrsDto = new HoursDTO();
    			hrsDto.modelNumber = modelNumber;
    			hrsDto.hours = hrs;
    			hrsDto.isFixed = isFixed;
    			hrsDto.crewTargetHourId = id;
    			hrsDto.version = version;
    		return hrsDto;
    	}

    	function SetFixedCrewData(dataList){
    		var fixedList = [];
    		for (var i = 0; i < dataList.length; i++) {
    			var hours = dataList[i].targetHrs;
    			for(var a =0; a < hours.length; a++){
    				if(hours[a].isFixed){
    					var dto = new FixedCrewDTO();
    					dto.crewProfileId = dataList[i].crewProfileId;
    					dto.targetHrs = hours[a].hours;
    					dto.targetNightHrs = dataList[i].targetNightHrs[a].hours;
    					dto.targetNightDepartures = dataList[i].targetNightDepartures[a].hours;
    					dto.modelNumber = hours[a].modelNumber;
    					fixedList.push(dto);
    				}
    			}
    		}
    		return fixedList;
    	}

    	function AdaptSaveData(targetHours){
    		var saveList = [];
            angular.forEach(targetHours, function (targetHour) {
            	var tHoursList = targetHour.targetHrs;
                for(var i = 0; i < tHoursList.length; i++){
	                	var save = new FixedCrewDTO();
	                	save.crewTargetHourId = tHoursList[i].crewTargetHourId;
	            		save.version = tHoursList[i].version;
	            		save.isFixed = tHoursList[i].isFixed;
	            		save.crewId = targetHour.crewId;
	            		save.crewName = targetHour.crewName;
	            		save.crewGroup = targetHour.crewGroup;
	            		save.past11MonthsHrs = targetHour.past11MonthsHrs;
	            		save.lastYearMonthHrs = targetHour.lastYearMonthHrs;
	            		save.calendarYearHrs = targetHour.calendarYearHrs;
	            		save.targetHrs = tHoursList[i].hours;
	            		save.accountedHrs = targetHour.accountedHrs;
	            		save.differneceHrs = targetHour.differneceHrs;
	            		save.availability = targetHour.availability;
	            		save.crewProfileId = targetHour.crewProfileId;
	            		save.targetNightHrs = targetHour.targetNightHrs[i].hours;
	            		save.targetNightDepartures = targetHour.targetNightDepartures[i].hours;
	            		save.modelNumber = tHoursList[i].modelNumber;
	            		save.targetDutyHrs = targetHour.targetDutyHrs[i].hours;
	            		save.targetSbHrs = targetHour.targetSbHrs[i].hours;
	            		save.crewAvailability = targetHour.crewAvailability;
	            		saveList.push(save);
                }
            });
            return saveList;
    	}

    	return{
    		getSearchCriteria:GetSearchCriteria,
    		getTargetHoursDto:GetTargetHoursDto,
    		getFormattedList :GetFormattedList,
    		setFixedCrewData :SetFixedCrewData,
    		getSaveRequest:GetSaveRequest,
    		adaptSaveData : AdaptSaveData
    	}

    }
})();
